import {actions as A} from '../../constants/actions';

const showGlobalErrorMessage = message => {
  return (dispatch) => {
    dispatch({
      type: A.SHOW_GLOBAL_ERROR_MESSAGE,
      payload: {message}
    });
  }
};

export {showGlobalErrorMessage}
